import { css } from "styled-components";
export var shadowDepth1 = css(["box-shadow:6px 6px 20px 0 rgba(0,0,0,0.16),0 6px 6px rgba(0,0,0,0.08);"]);
export var shadowDepth1Left = css(["box-shadow:-6px 6px 20px 0 rgba(0,0,0,0.16),0 6px 6px rgba(0,0,0,0.08);"]);
export var shadowDepth2 = css(["box-shadow:3px 3px 6px rgba(0,0,0,0.16),0 3px 6px rgba(0,0,0,0.08);"]);
export var shadowDepth3 = css(["box-shadow:0 2px 2px 0 rgba(0,0,0,0.16),0 0 0 1px rgba(0,0,0,0.08);"]);